import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import CurrentLocation from './UpdateMap';

const mapStyles = {
    width: '90%',
    height: '300px'
  };


class CustomerAddressDetails extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true,
            id: props.match.params.id,
            CustomerAddress: [],
            addressUpdated: false, 
            Notifications: false,
            DeliveryCirlce: '',
            DeliveryArea: '',
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {},          //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: '',
            landmark: '',
            label: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmUpdateAddress')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmUpdateAddress')[0].classList.add('was-validated');

        if(err==0)
        {
            $('#submitLoading').css('display','block');
            
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/customeraddaddress_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                //console.log(result);
                //alert(result);
                let notify = '';
                if(result.err!='')
                {
                    if(result.err=='1') notify = 'Delivery is currently unavailable in your area.';
                    else if(result.err=='2') notify = 'Delivery is currently unavailable in your area.';
                    else if(result.err=='3') notify = 'Delivery is currently unavailable in your area.';
                    else if(result.err=='4') notify = 'Unknown Customer';
                    else if(result.err=='5') notify = 'Address Field is Empty';
                    else if(result.err=='6') notify = 'Landmark Field is Empty';
                    else if(result.err=='7') notify = 'Label Field is Empty';
                    else if(result.err=='12') notify = 'Invalid Access Detected';
                    else if(result.err=='8') notify = 'Mobile Area Code Field is Empty';
                    else if(result.err=='9') notify = 'Mobile No Field is Empty';
                }

                let addressUpdated = false;
                let address_id = result.address_id;
                if(address_id!='' && address_id!=undefined)
                {
                    addressUpdated = true;
                }

                that.setState({ Notifications: notify, addressUpdated:addressUpdated });
                $('#submitLoading').css('display','none');
                if(notify!='')
                    $('#ModalAlert').modal('show');
                if(addressUpdated)
                    $('#ModalAlert2').modal('show');
            });
        }
    }

    fetchCustomerAddress(mode,customer,address_id) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customeraddressdetails_api.php?mode='+mode+'&customer='+customer+'&id='+address_id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_address = result.address;
            if(customer_address=='' || customer_address==undefined)
                customer_address = '';

            let mobileCode = result.mobileCode;
            if(mobileCode=='' || mobileCode==undefined)
                mobileCode = '+91';

            that.setState({ LOADING:false, CustomerAddress:customer_address, address:customer_address, lat:result.latitude, long:result.longitude, landmark:result.landmark, label:result.label, mobileCode:mobileCode, mobileNo:result.mobileNo });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        this.fetchCustomerAddress('ADDRESS_DETAILS',customer,this.state.id);
    }

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    handleGetAddress = (address,lat,long) => {
        this.setState({ address: address, lat:lat, long:long})
    }


    handleGetAddress2 = (lat,long) => {
        this.setState({ lat:lat, long:long})
    }

    updateGoogleMarker = (e) => {
        var address = e.target.value;
        if(address!='')
        {
            var that = this;
            fetch('https://m.donedelivery.in/api/addresslatlong_api.php?mode=LATLONG&address='+address,{
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*', 
                    Accept: 'application/json', 
                    'Content-Type': 'application/json',
                },
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                if(result.DATA=='Y')
                {
                    that.setState({ address: address, lat:result.LAT, long:result.LONG });
                }
            });
        }
    }

    onMarkerDragEnd = (coord) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();
        
        const requestOption = {
            method: 'GET'
        };
  
        //console.log(lat +','+ lng);
        let address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+lat+','+lng+'&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption)
        .then(res => res.json())
        .then(response => {

          address = response.results[0].formatted_address;
          this.setState({ address: address, lat:lat, long:lng})
          
        })
        .catch(error => {
            console.warn(error);
        });
  
    };

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    render() { 

        //localStorage.removeItem("userData");
        //localStorage.removeItem("cartData");
        //localStorage.removeItem("delCity");
        //localStorage.removeItem("delArea");
        //console.log(localStorage.getItem('userData'));

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        /*if(this.state.addressUpdated)
        {
            return (<Redirect to={'/addresses'}/>)
        }*/

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/addresses';
        let AppHeaderTitle = 'Update Address';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule" className="mt-1 p-0">
                    <div className="section full" style={{height: '300px', width: '100%', marginTop: '57px'}}>
                        <div id="map"> {/*onClick={this.onMarkerClick}*/}
                            {this.state.lat!='' && this.state.long!='' &&
                                <CurrentLocation
                                    centerAroundCurrentLocation
                                    google={this.props.google}
                                    handleGetAddress2={this.handleGetAddress2}
                                    initialCenter={{ lat: this.state.lat, lng: this.state.long }}
                                >
                                    <Marker
                                        draggable={true} 
                                        name={this.state.address} 
                                        onDragend={(t, map, coord) => this.onMarkerDragEnd(coord)}/>
                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        visible={this.state.showingInfoWindow}
                                        onClose={this.onClose}
                                    >
                                        <div>
                                            <h4>{this.state.selectedPlace.name}</h4>
                                        </div>
                                    </InfoWindow>
                                </CurrentLocation>
                            }
                        </div>
                    </div>
                    <div className="section pb-5 mt-1 mb-5">
                        <form id="frmUpdateAddress" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                            <input type="hidden" value="UPDATE_ADDRESS" className="form-control" name="mode" id="mode" />
                            <input type="hidden" value={this.state.id} className="form-control" name="address_id" id="address_id" />
                            <input type="hidden" value={localStorage.getItem('userData')} className="form-control" name="customer" id="customer" />
                            <input type="hidden" defaultValue={this.state.lat} className="form-control" name="lat" id="lat" required />
                            <input type="hidden" defaultValue={this.state.long} className="form-control" name="long" id="long" required />
                            
                            <div className="form-group boxed">
                                <div className="input-wrapper">
                                    <label className="label" htmlFor="txtaddress">Address:</label>
                                    <input type="text" className="form-control" name="txtaddress" id="txtaddress"  required defaultValue={this.state.address} autoComplete="off" onBlur={this.updateGoogleMarker} />
                                    <i className="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                    <div className="valid-feedback">&nbsp;</div> 
                                    <div className="invalid-feedback">Please enter your address.</div> 
                                </div>
                            </div>
                            <div className="form-group boxed">
                                <div className="input-wrapper">
                                    <label className="label" htmlFor="txtlandmark">Landmark:</label>
                                    <input type="text" className="form-control" id="txtlandmark" name="txtlandmark" defaultValue={this.state.landmark} required autoComplete="off"/>
                                    <i className="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                    <div className="valid-feedback">&nbsp;</div> 
                                    <div className="invalid-feedback">Please enter landmark.</div>  
                                </div>
                            </div>
                            <div className="form-group boxed">
                                <div className="input-wrapper">
                                    <label className="label" htmlFor="txtlabel">Label: Work, Office, Home, Other...</label>
                                    <input type="text" className="form-control" id="txtlabel" name="txtlabel" required autoComplete="off" defaultValue={this.state.label}/>
                                    <i className="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                    <div className="valid-feedback">&nbsp;</div> 
                                    <div className="invalid-feedback">Please enter label.</div>  
                                </div>
                            </div>
                            <div className="form-group boxed mb-1">
                                <div className="wid-20">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtcode">Code</label>
                                        <input type="text" className="square-inputbox form-control" name="txtcode" id="txtcode" required minLength="3" maxLength="6" autoComplete="off" defaultValue={this.state.mobileCode}/>
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div>
                                        <div className="invalid-feedback">Please enter your area code.</div>
                                    </div>
                                </div>
                                <div className="wid-80"> 
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtmobile">Mobile No</label>
                                        <input type="text" className="square-inputbox form-control" name="txtmobile" id="txtmobile" required minLength="10" maxLength="11" pattern="[0-9]{10}" autoComplete="off" defaultValue={this.state.mobileNo}/>
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div>
                                        <div className="invalid-feedback">Please enter your 10 digit mobile no.</div>
                                    </div>
                                </div>
                                <div className="clear"></div>
                            </div>
                            {/*<div className="form-button-group1 pr-2 pl-2">
                                <div className="col-12">
                                    <div className="text-upper">
                                        <div className="row">
                                            <div className="col-12">
                                                <button type="submit" className="text-upper btn btn-danger square lt-space1 btn-block skip">
                                                    <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                                    SAVE
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                            <div className="form-button-group1 pr-2 pl-2">
                                <div className="col-6">
                                    <div className="text-upper">
                                        <div className="row">
                                            <div className="col-12">
                                                <button type="submit" className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block">
                                                    <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                                    SAVE
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="text-upper">
                                        <div className="row">
                                            <div className="col-12">
                                                <Link to="/addresses" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-icon text-danger">
                                    <ion-icon name="close-circle"></ion-icon>
                                </div>
                                <div className="modal-body"> 
                                    {this.state.Notifications} 
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade dialogbox" id="ModalAlert2" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-icon text-success">
                                    <ion-icon name="checkmark-circle"></ion-icon>
                                </div>
                                <div className="modal-body"> 
                                    Address Details Updated Successfully 
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
  
//export default AddAddress2;
export default GoogleApiWrapper({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(CustomerAddressDetails)


// WEBPACK FOOTER //
// ./src/components/CustomerAddressDetails.js